<template>
    <div class="t-header">
        <div class="title">
            <div class="logo">
                <a href="/"><img class="logo-img" src="/static/images/logo2.png" alt=""></a>
            </div>
        </div>
        <div class="menu">
            <ul class="">
              <li v-if="isLogin" @mouseover="didshow" @mouseout="docClicked"><router-link to="/mine" class="u-name">{{username}}</router-link></li>
              <li v-else><router-link to="/login">登录/注册</router-link></li>
              <li class="item-show"><router-link to="/about">关于本站</router-link></li>
              <li class="item-show"><router-link to="/introne">扩展安装说明</router-link></li>
              <li><router-link to="/intrgoods">价格说明</router-link></li>
              <li class="item-show"><router-link to="/juliang">抖音指数</router-link></li>
              <li class="item-show"><router-link to="/homeedit">百度搜索指数</router-link></li>
              <li><router-link to="/">首页</router-link></li>
              <!-- <li><a href="/">首页</a></li> -->
            </ul>
            <div @mouseover="didshow" @mouseout="docClicked" class="dropdown-content" :class="{'dropdown-content-active': showMenu}">
              <a href="/mine" >个人中心</a>
              <a @click="setpasswd" >修改密码</a>
              <a @click="logout">退出</a>
            </div>

        </div>
    </div>
</template>
<script>
import helper from '../lib/helper'
import userhelper from '../lib/user'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
export default {
  data () {
    return {
      showMenu: false,
      email: '',
      isLogin: false,
      username: '个人中心'
    }
  },
  props: {
  },
  computed: {
  },
  mounted () {
    this.isLogin = userhelper.getLoginState()
    if (this.$store.state.vipinfo) {
      // this.getName(this.$store.state.vipinfo)
      this.username = helper.getName(this.$store.state.vipinfo)
    } else {
      this.getVipInfo()
    }
    const fpflag = helper.getFprint()
    if (!fpflag) {
      // this.check()
    }
  },
  watch: {
    '$store.state.isLogin': function (val, oldVal) {
      this.isLogin = val
    },
    '$store.state.vipinfo': function (val, oldVal) {
      this.username = helper.getName(val)
    }
  },

  methods: {
    check () {
      const fpPromise = FingerprintJS.load()
    ;(async () => {
      // Get the visitor identifier when you need it.
        const fp = await fpPromise
        const res = await fp.get()
        console.log(res.visitorId, res.components)
        const result = res.components
        let param = {}
        param.fp_id = res.visitorId
        param.fonts = JSON.stringify(result.fonts.value)
        param.domBlockers = JSON.stringify(result.domBlockers.value)
        param.fontPreferences = JSON.stringify(result.fontPreferences.value)
        param.audio = result.audio.value
        param.screenFrame = JSON.stringify(result.screenFrame.value)
        param.osCpu = result.osCpu.value
        param.languages = JSON.stringify(result.languages.value)
        param.colorDepth = result.colorDepth.value
        param.deviceMemory = result.deviceMemory.value
        param.screenResolution = JSON.stringify(result.screenResolution.value)
        param.hardwareConcurrency = result.hardwareConcurrency.value
        param.timezone = result.timezone.value
        param.sessionStorage = result.sessionStorage.value
        param.localStorage = result.localStorage.value
        param.indexedDB = result.indexedDB.value
        param.openDatabase = result.openDatabase.value
        param.cpuClass = result.cpuClass.value
        param.platform = result.platform.value
        param.plugins = JSON.stringify(result.plugins.value)
        // param.canvas = JSON.stringify(result.canvas.value)
        param.touchSupport = JSON.stringify(result.touchSupport.value)
        param.vendor = result.vendor.value
        param.vendorFlavors = JSON.stringify(result.vendorFlavors.value)
        param.cookiesEnabled = result.cookiesEnabled.value
        param.colorGamut = result.colorGamut.value
        param.invertedColors = result.invertedColors.value
        param.forcedColors = result.forcedColors.value
        param.monochrome = result.monochrome.value
        param.contrast = result.contrast.value
        param.reducedMotion = result.reducedMotion.value
        param.hdr = result.hdr.value
        param.math = JSON.stringify(result.math.value)
        param.video_vendor = result.videoCard.value.vendor
        param.video_rerender = result.videoCard.value.renderer

        console.log(param)
        var url = this.$store.state.baseurl + '/mapi/entry/check'
        this.axios.post(
          url,
          param
        ).then(function (res) {
          if (res.data.code === 200) {
            // console.log('登录成功', res.data)
            // console.log('vinfo', vinfo)
            helper.putFprint(true)
          } else {
            console.log('check error', res)
          }
        }).catch((e) => {
          console.log('获取数据失败 check', e)
        })
      })()
    },
    getVipInfo () {
      // 获取用户信息
      var that = this
      var url = this.$store.state.baseurl + '/mapi/user/getvip'
      this.axios.get(
        url,
        {
        }
      ).then(function (res) {
        if (res.data.code === 200) {
          var vinfo = res.data.data
          that.$store.commit('SETVIP', vinfo)
        } else {
          console.log('getvip error', res)
        }
      }).catch((e) => {
        console.log('获取数据失败', e)
      })
    },
    getName (val) {
      if (val && val.status === 1) {
        if (val.type === 0) {
          if (val.account && val.account > 10) {
            this.username = '钻石VIP'
          }
        }
        if (val.type === 1) {
          var t = helper.getCurTime()
          if (t < val.end_at) {
            if (val.s_type === 1) {
              this.username = '黄金VIP'
            }
            if (val.s_type === 2) {
              this.username = '铂金VIP'
            }
            if (val.s_type === 3) {
              this.username = '至尊VIP'
            }
          }
        }
      }
    },
    didshow () {
      this.showMenu = true
    },
    docClicked () {
      if (this.showMenu) {
        this.showMenu = false
      }
    },
    setpasswd () {
      window.location.href = '/setpwd'
    },
    logout () {
      var uinfo = helper.getUser()
      console.log('mine user info', uinfo)
      if (uinfo) {
        this.email = uinfo.email
      } else {
        window.location.href = '/login'
      }
      var url = this.$store.state.baseurl + '/mapi/user/logout'
      console.log('url', url)
      var that = this
      this.axios.get(
        url,
        {
        }
      ).then(function (res) {
        if (res.data.code === 200) {
          helper.removeLogin()
          helper.removeUser()
          window.location.href = '/login'
          console.log('获取用户信息', res.data)
        } else if (res.data.code === 401) {
          window.location.href = '/login'
        } else {
          that.$Message.info(res.data.msg)
          window.location.href = '/login'
        }
      }).catch((e) => {
        console.log('访问网络错误', e)
        that.$Message.info('访问网络错误')
      })
    }
  }
}
</script>
<style lang="less" scoped>
@media (max-width: 768px){
  .item-show {
    display: none;
  }
  .menu {
    margin: 20px 5px !important;
  }
}

.t-header {
  width: 100%;
  height: 60px;
  background-color: #398dee;
  a:link{color: #fff;}
  a:visited{color: #fff;}
  .title {
      float: left;
  }
  .logo-lettler {
      color: #fff;
      font-size: 30px;
      font-weight: 600;
      margin: 0 5px;
      display: inline-block;
  }
  .logo {
      position: relative;
      top: 6px;
      display: inline-block;
      margin-left: 2px;
  }
  .logo-img {
      width: 145px;
      height: auto;
  }
  .menu {
      float: right;
      color: #fff;
      margin: 20px 20px;
      position: relative;
      li {
          font-size: 16px;
          font-weight: 500;
          float: right;
          margin: 0 5px;
      }
  }
  .u-name {
    position: relative;
  }
  .dropdown-content {
    display: none;
    position: absolute;
    min-width: 90px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    border-radius: 6px;
    font-family:PingFangSC-Regular,PingFang SC, Arial, "Microsoft YaHei", "微软雅黑", sans-serif;
    z-index: 11;
    background-color: #fff;
    padding: 6px;
    top: 23px;
    right: -10px;
    a:hover {color: #398dee;}
    a {
      display: block;
      font-size: 14px;
      line-height: 25px;
      color: #515a6e;
    }
  }
  .dropdown-content-active {
    display: block;
  }
  @media (max-width: 768px){
    .u-name {
      display: inline-block;
      width: 64px; /* 指定宽度 */
      white-space: nowrap; /* 不换行 */
      overflow: hidden; /* 隐藏溢出内容 */
      text-overflow: ellipsis; /* 显示省略号 */}
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue